export const Spinner = () => (
  <div className="flex items-center justify-center py-24" data-testid="spinner">
    <div className="h-10 w-10 animate-spin rounded-full border-2 border-[#D4AF37] border-t-transparent" />
  </div>
);

export const PageHeader = ({ caption, title, subtitle }) => (
  <div className="fade-up mx-auto max-w-7xl px-4 pb-10 pt-28 text-center sm:px-8 sm:pt-32">
    {caption && <p className="caption">{caption}</p>}
    <h1 className="mt-3 font-serif text-4xl font-bold tracking-tight sm:text-5xl">{title}</h1>
    {subtitle && <p className="mx-auto mt-4 max-w-2xl text-base text-zinc-400">{subtitle}</p>}
  </div>
);

export const EmptyState = ({ text }) => (
  <div className="card-dark mx-auto max-w-md p-10 text-center" data-testid="empty-state">
    <p className="font-serif text-xl text-[#E5C158]">Nothing here yet</p>
    <p className="mt-2 text-sm text-zinc-400">{text}</p>
  </div>
);
